var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Icones",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ic\\xF4nes",
    transform: "translate(-725.000000, -436.000000)",
    fill: "#04246A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components-/-02-Icon-/-16-/-Magnifying-Glass",
    transform: "translate(725.000000, 436.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,6.75 C2,4.131 4.131,2 6.75,2 C9.369,2 11.5,4.131 11.5,6.75 C11.5,9.369 9.369,11.5 6.75,11.5 C4.131,11.5 2,9.369 2,6.75 M14.854,14.146 L11.152,10.445 C11.992,9.446 12.5,8.158 12.5,6.75 C12.5,3.574 9.926,1 6.75,1 C3.574,1 1,3.574 1,6.75 C1,9.926 3.574,12.5 6.75,12.5 C8.158,12.5 9.446,11.992 10.445,11.152 L14.146,14.854 C14.244,14.951 14.372,15 14.5,15 C14.628,15 14.756,14.951 14.854,14.854 C15.049,14.658 15.049,14.342 14.854,14.146",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFind);
export default __webpack_public_path__ + "static/media/icon_find.ca9eeeaa212b3e26d272cbfcc35d8d70.svg";
export { ForwardRef as ReactComponent };